import type { ReactNode } from 'react';

import type { Maybe } from '@/lib/types';

import * as S from './SliderOverlay.styles';

export interface SliderOverlayProps {
  backgroundColor?: Maybe<string>;
  backgroundOffset?: number;
  backgroundSrc?: Maybe<string>;
  children: ReactNode;
}

export const SliderOverlay = ({
  backgroundColor,
  backgroundOffset = 0,
  backgroundSrc,
  children,
}: SliderOverlayProps) => {
  return (
    <S.Wrapper
      $backgroundColor={backgroundColor}
      backgroundOffset={backgroundOffset}
      backgroundSrc={backgroundSrc}
      data-test-id='SliderOverlayWrapper'
    >
      {children}
    </S.Wrapper>
  );
};

SliderOverlay.displayName = 'SliderOverlay';
